/*
Generate links back to the platform with less hassle.

On portfolio subdomains (e.g. username.contently.com), returns relative paths
instead of absolute URLs to avoid cross-origin requests. The portfolio subdomain
routes to the same Rails app, so /api/v1/user works identically on both origins.
 */
import RuntimeEnvironment from '../../config/runtime';

export default class PlatformLinkBuilder {
  static build(path?: string | null) {
    if (window.__PORTFOLIO_USERNAME__) {
      return path || '/';
    }
    return new URL(path ? path : '', RuntimeEnvironment.platform.host).href;
  }
}
